<template>
  <v-footer class="bt4 pa-4 blue-grey darken-4 d-flex justify-space-around">
    <span class="white--text text-center py-2">{{ name }} © 2020. Todos os direitos reservados.</span>
    <img src="/img/mrx.png" alt="MRX Web Sites" title="MRX Web Sites">
  </v-footer> 
</template>

<script>
export default {
  data: () => ({
    logo: '/img/favicon-white.svg',
  }),
  computed: {
    name() {
      return this.$store.state.holder.name
    }
  }
}
</script>

<style scoped>
  .bt4{
    border-top: 5px solid #e1b768 !important;
  }
</style>